import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";

export const PhotoViewer = ({ photo, onClose }) => (
  <DialogPrimitive.Root open={!!photo} onOpenChange={(o) => { if (!o) onClose(); }}>
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay className="viewer-overlay" />
      <DialogPrimitive.Content className="viewer-content" onClick={onClose} aria-describedby={undefined} data-testid="photo-viewer">
        <DialogPrimitive.Title className="sr-only">{photo?.alt ?? "Photo"}</DialogPrimitive.Title>
        {photo && (
          <figure className="viewer-figure" onClick={(e) => e.stopPropagation()}>
            <img src={photo.src} alt={photo.alt} data-testid="photo-viewer-image" />
            {photo.label && <figcaption>{photo.label}</figcaption>}
          </figure>
        )}
        <DialogPrimitive.Close className="viewer-close" aria-label="Close photo" data-testid="photo-viewer-close">
          <X size={28} />
        </DialogPrimitive.Close>
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  </DialogPrimitive.Root>
);
